import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const InvoiceChangeLotsDialogTourConfig: AgTechTourConfig = {
    id: 'invoice-change-lots-dialog-tour',
    name: 'Update Invoice Lots Tour',
    steps: [
        {
            targetId: 'invoice-change-lots-summary',
            title: 'Invoice Math',
            description: 'Lots sold, less charges and discounts, less credits applied, equals the invoice amount. It updates live as you select or deselect lots.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-change-lots-grid',
            title: 'Lots on the Invoice',
            description: 'Select the lots that belong on this invoice. Lots bought by this contact that are not on another invoice are listed here. Click Update to save.',
            position: 'top',
        },
    ]
}
